import { FC } from "react";

declare global {
  namespace JSX {
    interface IntrinsicElements {
      "markdown-toolbar": React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement> & { for: string },
        HTMLElement
      >;
      "md-italic": React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement>,
        HTMLElement
      >;
      "md-bold": React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement>,
        HTMLElement
      >;
      "md-quote": React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement>,
        HTMLElement
      >;
      "md-unordered-list": React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement>,
        HTMLElement
      >;
      "md-link": React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement>,
        HTMLElement
      >;
      "md-image": React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement>,
        HTMLElement
      >;
      "md-ordered-list": React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement>,
        HTMLElement
      >;
      "md-task-list": React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement>,
        HTMLElement
      >;
    }
  }
}

import { Flex, IconButton, TextArea } from "@radix-ui/themes";
import {
  FontBoldIcon,
  FontItalicIcon,
  ImageIcon,
  Link1Icon,
  ListBulletIcon,
  PilcrowIcon,
} from "@radix-ui/react-icons";
import "@github/markdown-toolbar-element";

const MarkdownToolbar: FC = (): JSX.Element => {
  return (
    <markdown-toolbar for="news-content">
      <Flex gap="4">
        <Flex gap="1">
          <md-italic>
            <IconButton variant="soft" highContrast color="gray">
              <FontItalicIcon />
            </IconButton>
          </md-italic>

          <md-bold>
            <IconButton variant="soft" highContrast color="gray">
              <FontBoldIcon />
            </IconButton>
          </md-bold>
        </Flex>

        <Flex gap="1">
          <md-quote>
            <IconButton variant="soft" highContrast color="gray">
              <PilcrowIcon />
            </IconButton>
          </md-quote>
          <md-unordered-list>
            <IconButton variant="soft" highContrast color="gray">
              <ListBulletIcon />
            </IconButton>
          </md-unordered-list>

          {/* <md-ordered-list>ordered-list</md-ordered-list>
              <md-task-list>task-list</md-task-list> */}
        </Flex>

        <Flex gap="1">
          <md-link>
            <IconButton variant="soft" highContrast color="gray">
              <Link1Icon />
            </IconButton>
          </md-link>

          <md-image>
            <IconButton variant="soft" highContrast color="gray">
              <ImageIcon />
            </IconButton>
          </md-image>
        </Flex>
      </Flex>
    </markdown-toolbar>
  );
};

export default MarkdownToolbar;
